import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GestaRequisitarCartoesService {

  constructor(
    private http: HttpService,
  ) { }

  buscaOnboard(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/card/request/situation', data, successHandle, errorHandle);

  }

}
